import { render } from "./ColourCodedPriorityIcon.vue?vue&type=template&id=b462c0b2&scoped=true"
import script from "./ColourCodedPriorityIcon.vue?vue&type=script&lang=js"
export * from "./ColourCodedPriorityIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b462c0b2"]])

export default __exports__